const clientLogger = require('@tencent/intl-log/src/client-logger');

// 兼容 Next Middleware window 处理
let isClientContext;
try {
  isClientContext = Object.keys(window).length !== 0;
} catch (error) {
  isClientContext = false;
}
let logger = clientLogger;
if (!isClientContext) {
  logger = require('@tencent/intl-log/src/server-logger');
}

// 日志配置
// 目前只有日志打印级别控制，此部分可改成读取本地某个目录的配置，如果未配置使用默认值即可
const config = {};
config.logLevel = 'info';
logger.setConf(config);

module.exports = logger;
